import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// @mui
import {  
  Box,
  Modal,
  Button,
  Stack,
  Autocomplete,
  TextField
} from '@mui/material';
import { cores, labelCampoEscuro } from '../styles/styleUtils';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  height: '50vh',
  '@media screen and (max-width: 600px)': {
    width: '50vw', // Width de 100% para telas de celulares
    height: '50vh',
  },
  bgcolor: 'transparent',
  border: `1px solid ${cores.chumbo}`, borderTop: `4px solid ${cores.laranja}`,
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
  alignItems: 'center',
  justifyContent: 'center'
};



// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const ModalTipoContratante = React.forwardRef((props, ref) => {
  
  // const [responsavel, setResponsavel] = useState(null)
  const [tipo, setTipo] = useState(null)
  // const [usuarios, setUsuarios] = useState([]);
  const tipos = [
    {
      id: 'F',
      nome: 'Pessoa Física'
    },
    {
      id: 'J',
      nome: 'Pessoa Jurídica'
    }
  ]

  const onConfirm = () => {
    props.onConfirm(tipo)
  }

  return (


    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <strong style={{ color: cores.textoClaro }}>Selecione o Tipo Contrante</strong>
          <Autocomplete
            disablePortal
            id="usuario"
            value={tipo}
            onChange={(event, newValue) => {
              setTipo(newValue)
            }}
            options={tipos}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            sx={{width: 400, mb: 2, mt:3, backgroundColor: 'white', ...labelCampoEscuro}}
            renderInput={(params) => <TextField {...params} label="Tipo Contrante" />}
          />
          <Stack direction={'row'} justifyContent={'space-between'} gap={20} mt={5} >
            <Button variant="outlined" onClick={props.onClose} color="error"> Cancelar</Button>
            <Button variant="contained" disabled={!tipo} color="success" onClick={onConfirm}>Selecionar</Button>
          </Stack>
        </Box> 
    </Modal> 
  );
})

ModalTipoContratante.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
}

export default (ModalTipoContratante);